var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import { getCountries } from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
const CountryDropDown = forwardRef((props, ref) => {
    const { helperText, error } = props, selectProps = __rest(props, ["helperText", "error"]);
    return (_jsxs(FormControl, Object.assign({ fullWidth: true, variant: "outlined", required: props.required, error: Boolean(error) }, { children: [_jsx(InputLabel, Object.assign({ id: "country-label" }, { children: props.label })), _jsx(Select, Object.assign({}, selectProps, { labelId: "country-label", inputRef: ref }, { children: getCountries()
                    .sort((a, b) => en[a].localeCompare(en[b]))
                    .map((country) => (_jsx(MenuItem, Object.assign({ value: country }, { children: en[country] }), country))) })), !!helperText && _jsx(FormHelperText, { children: helperText })] })));
});
export default CountryDropDown;
